exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#become-an-observer[data-v-dfeb22a2]{background-color:#000}#become-an-observer h1[data-v-dfeb22a2]{color:#ffca00;font-weight:bolder;font-size:3em}#become-an-observer #form[data-v-dfeb22a2]{background-color:#fff;margin:10px}", ""]);

// exports
